import {AppState} from "../types";

export const selectAdminLoading = (store: AppState) => store.admin.isLoading;
export const selectAdminError = (store: AppState) => store.admin.error;
export const selectUsersList = (store: AppState) => store.admin.users;
export const selectTokensList = (store: AppState) => store.admin.tokens;
export const selectStatistics = (store: AppState) => store.admin.stats;
export const selectFeatureToggles = (store: AppState) => store.admin.featureToggles;
export const selectCustomerInfo = (store: AppState) => store.admin.customerInfo;
